import { makeStyles } from '@mui/styles';
import FormControl from '@mui/material/FormControl';
import { TextField } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types'

const useStyles = makeStyles(() => ({
  formControl: {
    margin: 15,
    minWidth: 120,
    width: '40%'
  },
  inputLabel: {
    fontSize: '14px'
  }
}));

const theme = createTheme({
  overrides: {
    MuiInputLabel: {
      root: {
        fontSize: '14px'
      }
    }
  },
});

export default function MinMaxFilter({min, max, setMin, setMax}) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleChangeMin = (event) => {
    dispatch(setMin(event.target.value));
  };

  const handleChangeMax = (event) => {
    dispatch(setMax(event.target.value));
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <FormControl className={classes.formControl}>
          <TextField
            id="standard-number"
            label="Min"
            type="number"
            variant="standard"
            className='inputLabel'
            onChange={handleChangeMin}
            value={min === null ? "" : min}
            name="min"
          />
        </FormControl>
        <FormControl className={classes.formControl}>
          <TextField
            id="standard-number"
            label="Max"
            type="number"
            variant="standard"
            className='inputLabel'
            onChange={handleChangeMax}
            value={max === null ? "" : max}
            name="max"
          />
        </FormControl>
      </ThemeProvider>
    </div>
  );
}

MinMaxFilter.propTypes = {
  min: PropTypes.any, 
  max: PropTypes.any, 
  setMin: PropTypes.func, 
  setMax: PropTypes.func
}
